/* eslint-disable react/display-name */
/* eslint-disable no-console */
import React, { ChangeEvent } from "react";
import classNames from "classnames";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useMediaQuery } from "react-responsive";
import { BookingCustomerInput } from "../../molecules/Booking/BookingCustomerInput";
import { BookingCommentInput } from "../../molecules/Booking/BookingCommentInput";
import { Form, notification } from "../../atoms";
import { CartTotalHotelBookingBtn, HotelCart, Loader } from "../../molecules";
import { userFirestoreDoc } from "../../../hooks/useFirestoreDoc";
import {
  listenToBooking30512HotelFromFirestore,
  updateBooking30512HotelInFirestore,
} from "../../../firestore/firestoreService";
import { IHotelBookingInput } from "../../../common/types";
import { BookingRoomInput } from "../../molecules/Booking";
import { axiosGet, axiosPost } from "../../../config/axios";
import { HotelWrapper } from "./Hotel.style";

const VIVA_PAYMENT_BASED_URL =
  "https://vivahotelpayment-futhw57ila-ew.a.run.app";
const partnerId = process.env.REACT_APP_SITE_ID || "";
const BookingTimer: React.FC = React.memo(() => {
  const [remainingSeconds, setRemainingSeconds] = React.useState(30 * 60);

  React.useEffect(() => {
    if (remainingSeconds <= 0) return;
    const timerId = window.setInterval(() => {
      setRemainingSeconds((prev) => Math.max(prev - 1, 0));
    }, 1000);
    return () => window.clearInterval(timerId);
  }, [remainingSeconds]);

  const formatRemaining = (totalSeconds: number) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  return (
    <div className="hotel-booking-timer">
      Ολοκληρώστε την κράτηση μέσα σε{" "}
      <span>{formatRemaining(remainingSeconds)}</span>
    </div>
  );
});

export const HotelBooking: React.FC = ({}) => {
  const [form] = Form.useForm();
  const history = useNavigate();
  const [loadingPayment, setLoading] = React.useState(false);
  const [errorPayment, setError] = React.useState("");
  const [showCart, setShowCart] = React.useState(true);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1200px)" });
  const dispatch = useDispatch();
  const params = useParams();
  const [booking, setBooking] = React.useState<IHotelBookingInput>();
  const { selectedCustomer14860 } = useSelector(
    (state: any) => state.customers,
  );

  const bookingId = params.bookingId || "";
  const handleOnFinish = (type: string) => async () => {
    try {
      const values: IHotelBookingInput = await form.validateFields();
      // eslint-disable-next-line no-console
      console.log(values.rooms);
      await updateBooking30512HotelInFirestore(bookingId, {
        ...booking,
        status: type === "ON_REQUEST" ? "ON_REQUEST" : "IN_PROGRESS",
        comment: values?.comment || "",
        customer:
          {
            ...values.customer,
            dateOfBirth: moment(values.customer?.dateOfBirth || "").format(
              "YYYY-MM-DD",
            ),
          } || null,
        customerId: selectedCustomer14860?.id || "",
        rooms: booking?.rooms.map((room: any) => ({
          ...room,
          mainGuest: {
            ...values.roomsMainGuest[room.id],
            dateOfBirth: moment(
              values.roomsMainGuest[room.id]?.dateOfBirth || "",
            ).format("YYYY-MM-DD"),
          },
        })),
        initialPayment: type,
      });
      if (type === "PARIETAL_PAYMENT") {
        await handlePayment("PARTIAL_PAYMENT");
      } else if (type === "FULL_PAYMENT") {
        await handlePayment("FULL_PAYMENT");
      } else {
        history(`/hotel-booking-on-request-confirm/${bookingId}`);
      }
    } catch (errorInfo: any) {
      notification.error({
        message: "Update Failed",
        description: errorInfo.message,
      });
    }
  };
  const handlePayment = async (type: string) => {
    try {
      setLoading(true);
      const { data } = await axiosGet(`${VIVA_PAYMENT_BASED_URL}/get-token`);
      if (data.token) {
        const { data: dataApi, status } = await axiosPost(
          `${VIVA_PAYMENT_BASED_URL}/hotel-booking-create-transaction`,
          { token: data.token, bookingId, type },
        );
        if (status === 200) {
          window.location.href = dataApi.checkOutUrl;
        }
      } else {
        throw new Error(`No Token`);
      }

      setLoading(false);
    } catch (errorInfo) {
      setLoading(false);
      if (typeof errorInfo === "string") {
        setError(errorInfo.toUpperCase());
      } else if (errorInfo instanceof Error) {
        setError(errorInfo.message);
      }
    }
  };
  const handelShowCart = () => {
    setShowCart((v) => !v);
  };
  userFirestoreDoc({
    query: () => listenToBooking30512HotelFromFirestore(bookingId),
    data: setBooking,
    shouldExecute: !!bookingId,
    deps: [dispatch, bookingId],
    local: true,
  });

  const handleUpdateField =
    (fieldName: string) =>
    (
      input:
        | string
        | number
        | boolean
        | ChangeEvent<
            HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
          >,
    ) => {
      const value =
        typeof input === "object" && input !== null && "target" in input
          ? // Event object → pull out target.value
            (
              input.target as
                | HTMLInputElement
                | HTMLSelectElement
                | HTMLTextAreaElement
            ).value
          : // Primitive value passed directly
            input;

      form.setFieldValue(
        ["roomsMainGuest", booking?.rooms[0]?.id, fieldName],
        value,
      );
    };
  React.useEffect(() => {
    if (!isTabletOrMobile) {
      setShowCart(false);
    } else {
      setShowCart(true);
    }
  }, [isTabletOrMobile]);
  React.useEffect(() => form.resetFields, [selectedCustomer14860, booking]);

  React.useEffect(() => {
    if (booking && booking?.status !== "NEW") {
      history("/");
    }
  }, []);

  if (!booking) return <Loader title="Booking Loading" color={"#fff"} />;

  return (
    <HotelWrapper>
      <div className="hotel hotel-detail">
        <div className="hotel-body">
          <div className="hotel-result">
            <BookingTimer />
            <Form
              form={form}
              name="horizontal_login"
              layout="vertical"
              autoComplete="off"
              initialValues={{
                ...booking,
                customer: {
                  name: selectedCustomer14860?.name || "",
                  email: selectedCustomer14860?.email || "",
                  phone: selectedCustomer14860?.phone || "",
                  id: "",
                },
                roomsMainGuest: booking.rooms?.[0]?.id
                  ? {
                      [booking.rooms[0].id]: {
                        name: selectedCustomer14860?.name || "",
                      },
                    }
                  : {},
              }}
            >
              <BookingCustomerInput
                form={form}
                partnerId={partnerId}
                updateField={handleUpdateField}
              />
              {booking.rooms.map((room) => (
                <BookingRoomInput
                  key={room.id}
                  title={""}
                  hotelId={booking.hotelId}
                  room={room}
                  showDateOfBirth
                  partnerId={booking?.partnerId}
                />
              ))}
              <BookingCommentInput />
              <CartTotalHotelBookingBtn
                submit={handleOnFinish}
                loading={false}
                discount={0}
                totalPartialPayment={booking.partialPayment}
                cancellationPolicy={""}
                refundableDate={booking.refundableDate}
                totalNonRefundableAmount={0}
                allowPartialPayment={booking.allowPartialPayment}
                bookingId={booking.id}
                customerId={booking.customerId}
                partnerId={booking.partnerId || ""}
                totalPrice={booking.totalPayment}
                couponCode={booking.couponCode}
                couponValue={booking.couponDiscount}
                loadingPayment={loadingPayment}
                errorPayment={errorPayment}
                finalPrice={booking.totalPrice}
                onRequest={!!booking.onRequest}
                isTabletOrMobile={isTabletOrMobile}
              />
            </Form>
          </div>
          <div className={classNames("hotel-right", { hideRight: showCart })}>
            <HotelCart
              rooms={booking.rooms}
              startDate={booking.checkIn}
              endDate={booking.checkOut}
              hotelId={booking.hotelId}
              exclusiveOfferId={booking.exclusiveOfferId}
              checkInCheckOut={`${booking.checkIn} - ${booking.checkOut}`}
              totalPrice={booking.totalPayment}
              sellPrice={booking.sellPrice}
              netPrice={booking.netPrice}
              onShowCart={handelShowCart}
              isTabletOrMobile={isTabletOrMobile}
              hotelName={booking.hotelName}
            />
          </div>
        </div>
      </div>
    </HotelWrapper>
  );
};
